import { EnvService } from "namirasoft-core";
import { NSButtonGreen, NSColumn, NSLabel, NSLine, NSRow } from "namirasoft-site-react";
import { Component } from "react";

export interface NSASectionTabsMoreProps
{
	deleteFieldCache: () => void;
}

export interface NSASectionTabsMoreState
{ }

export class NSASectionTabsMore extends Component<NSASectionTabsMoreProps, NSASectionTabsMoreState>
{
	override render()
	{
		return (
			<NSColumn
			>
				<NSLabel
					title="Namirasoft Field - Field"
					desciption="Here you can see the list of fields that are available in the system."
				></NSLabel>
				<NSRow>
					<NSButtonGreen
						title="See Field List"
						onClick={{
							action: () =>
							{
								let REACT_APP_BASE_URL_FIELD_CONSOLE = new EnvService("REACT_APP_BASE_URL_FIELD_CONSOLE", true).getString();
								window.open(REACT_APP_BASE_URL_FIELD_CONSOLE + "/field/list", "_blank");
							},
							showLoading: false
						}}
					></NSButtonGreen>
				</NSRow>
				<NSLine />
				<NSLabel
					title="Namirasoft Field - Category"
					desciption="Here you can see the list of categories that are available in the system."
				>
				</NSLabel>
				<NSRow>
					<NSButtonGreen
						title="See Category List"
						onClick={{
							action: () =>
							{
								let REACT_APP_BASE_URL_FIELD_CONSOLE = new EnvService("REACT_APP_BASE_URL_FIELD_CONSOLE", true).getString();
								window.open(REACT_APP_BASE_URL_FIELD_CONSOLE + "/category/list", "_blank");
							},
							showLoading: false
						}}
					></NSButtonGreen>
				</NSRow>
				<NSLine />
				<NSLabel
					title="Namirasoft Field"
					desciption="We use a 24-hour cache to speed up rendering the page, so if you have recently made changes and you do not see it here, please clear it using the following button."
				>
				</NSLabel>
				<NSRow>
					<NSButtonGreen
						title="Clear Cache"
						onClick={{
							action: () =>
							{
								this.props.deleteFieldCache?.();
								document.location.reload();
							},
							showLoading: false
						}}
					></NSButtonGreen>
				</NSRow>
			</NSColumn>
		);
	}
}